export default {
  add: "Add Items",
  sale: "Sale Items",
  items: "Items",
  summary: "Summary",
  notifications: "Notifications",
  registerinfo:
    "This is your new user name and ID. Please remember this ID because it will be used for logging into the website.",
  companyProfiles: "Company Profiles",
  bills: "Bills",
  ledger: "Ledgers",
  purchase: "Purchase Orders",
  sale_return: "Sale Return",
  bill_template: "Bill Template",
  finalizedOrders: "Finalized Orders",
  saleLedgers: "Sale Ledgers",
  purchaseLedgers: "Purchase Ledgers",
  dashboard: "Dashboard",
  orders: "Orders",
  salereturnbills: "Return bills",
  quotation: "Quotation",
  daily_book: "Day Book",
  warehouse: "Warehouse",
  vouchers: "Vouchers",
  voucheritems: "Voucher Items",
  rack: "Rack",
  reports: "Reports",
  bank: "Bank",
  invoice: "Invoice",
};
